<div
  class="flex gap-2 items-center justify-center"
  data-testId="user-details-summary"
>
  <div
    class="flex flex-row justify-center w-6 h-6 p-1 bg-neutral-100 font-semibold text-xs whitespace-nowrap rounded-full"
  >
    {{ userForDisplay() | flxUserInitials }}
  </div>
  {{ userForDisplay().firstName }} {{ userForDisplay().lastName }} ({{ userForDisplay().email }})

  <flx-status
    [label]="userForDisplay().status.label"
    [severity]="userForDisplay().status.severity"
    [attr.data-testid]="'user-status'"
  />
</div>
